
import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import {ActionDefinition, Inventory} from '../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import DefinitionEditorDutySpecific from './DefinitionEditorDutySpecific';
import DefinitionEditorSurveyResultSpecific from "./DefinitionEditorSurveyResultSpecific";
import DefinitionEditorDutyAlarmSurveySpecific from "./DefinitionEditorDutyAlarmSurveySpecific";
import DefinitionEditorSurveyResultMqttSpecific from "./DefinitionEditorSurveyResultMqttSpecific";
import DefinitionEditorMqttSubscriberSpecific from "./DefinitionEditorMqttSubscriberSpecific";
import DefinitionEditorMqttFromVisitorManagementSpecific from "./DefinitionEditorMqttFromVisitorManagementSpecific";

export const availableTypes = [ // see ActionsExtensions.cs for registered types, keep in sync
  'duty.specific',
  'survey_result.create_job',
  'duty_survey.sms_alarm',
  'survey_result.publish_mqtt_cell',
  'mqtt_subscriber_action',
  'visitor_management_action',
];

@Component({
  components: {
    DefinitionEditorMqttFromVisitorManagementSpecific,
    DefinitionEditorMqttSubscriberSpecific,
    DefinitionEditorSurveyResultMqttSpecific,
    DefinitionEditorDutyAlarmSurveySpecific,
    DefinitionEditorSurveyResultSpecific,
    DefinitionEditorDutySpecific,
    vSelect,
  },
})
export default class DefinitionEditModal extends Vue {
  @Prop({ required: true })
  definition!: ActionDefinition;
  
  private subComponentsCanSave = false;
  
  get availableTypesForVSelect(): { type: string, label: string }[] {
    return availableTypes.map(e => ({
      type: e,
      label: this.$t('actions.actionDefinition.model.types.' + e).toString(),
    }));
  }

  created(): void {
    this.definition.name = "";
  }
    
  get parsedJsonParameters(): any {
    return JSON.parse(this.definition.configurationJson) ?? {};
  }

  onParsedJsonChanged(parsedJsonParameters: any) {
    this.definition.configurationJson = JSON.stringify(parsedJsonParameters);
  }

  @Watch('definition.name')
  private async onNameChanged() {
   this.onCanSaveChanged(this.subComponentsCanSave);
  }


  @Watch('definition.type')
  private async onSelectChanged() {
    this.subComponentsCanSave = false;
    this.onCanSaveChanged(this.subComponentsCanSave);
  }
  onCanSaveChanged(canSave: boolean) {
    this.subComponentsCanSave = canSave;
    this.$emit('canSaveChanged', this.subComponentsCanSave && (this.definition.name !== null && this.definition.name !== ""));
  }
}
